import styled from "styled-components"
import { ButtonStyleGreen } from "../../Core/Buttons/Styles"
import fonts from "../../../styles/fonts"
import breakpoints from "../../../styles/breakpoints"
import colors from "../../../styles/colors"

export const Title = styled.h2`
  ${fonts.selfModern};
  font-size: 34px;
  line-height: 32px;
  text-align: center;
  color: ${colors.trueBlack};
  @media (min-width: ${breakpoints.md}) {
    font-size: 50px;
    line-height: 48px;
  }
`

export const Intro = styled.p`
  color: ${colors.mediumGrey};
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.26px;
  text-align: center;
`
export const Fields = styled.div`
  position: relative;
`

export const SubmitButton = styled.button`
    ${ButtonStyleGreen};
    width: 100%;
    pointer-events: ${(props) => props.disabled && "none"};
    cursor: ${(props) => props.disabled && "normal"};
    background: ${(props) => props.disabled && colors.green};
    border: 2px solid ${colors.green};
    border-color: ${(props) => props.disabled && colors.green};
    color: ${(props) => props.disabled && colors.beige};
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.3px;
    ${fonts.helveticaNeueCondensedBold};
    padding: 17px 40px;

    &:hover {
      background: ${(props) => props.disabled && colors.white};
      color: ${(props) => props.disabled && colors.green};
      border: 2px solid ${colors.green};
    }
`
